export enum State {
  PERSONAL_ADDRESS = 'personal-address',
  COMPLIANCE = 'compliance',

  DONE = 'done',
  ABORT = 'abort',
}
